import { BrowserRouter, Routes, Route } from "react-router-dom";
import Blog from "./pages/blog";
import BlogArticle from './pages/BlogArticle';
import Collection from "./pages/Collection";
import './styles/global.css';

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/collection" element={<Collection />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;